













































































































import _ from "lodash";
import rest from "@/rest";
import router from "@/router";
import { Component, Vue, Prop } from "vue-property-decorator";
import { vuex } from "@/store";
import { namespace } from "vuex-class";
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
// Components
import FileDrop from '@/components/Shared/FileDrop.vue';
import StockPriceChart from '@/components/Admin/StockPriceChart.vue';

// interfaces
import { ParamDictionary } from "@/interfaces/ParamDictionary";
import { CustomizationVm } from "@/interfaces/CustomizationVm";
import { AiStockMarketSummaryVm } from "@/interfaces/AiStockMarketSummaryVm";
import { AiChartAnalysisVm } from "@/interfaces/AiChartAnalysisVm";
import NumberInput from "@/components/Shared/NumberInput.vue";
import ExpandableCard from "@/components/Shared/ExpandableCard.vue";

const auth = namespace("auth");
const customization = namespace("customization");

@Component({
  components: {
    FileDrop,
    NumberInput,
    ExpandableCard,
    StockPriceChart
  }
})
export default class AiStockMarketAgentView extends Vue {
  @auth.Getter isAdmin: any;
  // @customization.Action saveCustomizationSettings!: any;
  @customization.Getter customizationSettings!: CustomizationVm;

  busy = false;
  stockMarketSummary: AiStockMarketSummaryVm | null = null;
  aiChartAnalysis: AiChartAnalysisVm | null = null;

  // $refs!: {
  // }

  async mounted() {
    if (!this.isAdmin)
      router.push("/");
  }

  created() {
    // Disable body scroll on iOS
    this.$nextTick(async () => {
      await this.$globalHelper.delay(10);
      const modal = document.querySelector('.modal');
      disableBodyScroll(modal);
    });
  }

  beforeDestroy() {
    clearAllBodyScrollLocks();
  }

  async onGetAiStockMarketSummery() {
    this.busy = true;
    try {
      // rest call to get ai stock market summery
      await rest.url("admin/getAiStockMarketSummery")
        .get()
        .then((response) => {
          this.stockMarketSummary = response;
        });
    } finally {
      this.busy = false;
    }
  }

  async onGetAiChartAnalysis(isin: string) {
    this.busy = true;
    try {
      // rest call to get ai chart analysis for isin
      await rest.url("admin/getAiChartAnalysis")
        .query({ isin: isin })
        .get()
        .then((response) => {
          this.aiChartAnalysis = response;
        });
    } finally {
      this.busy = false;
    }
  }

  get chartTitle() {
    if (this.aiChartAnalysis)
      return `${this.aiChartAnalysis.name ?? ""} ${this.aiChartAnalysis.isin ?? ""} (${this.aiChartAnalysis.currency ?? ""})`.trim();
    return "Chart Analysis";
  }

  get chartTitleSmall() {
    if (this.aiChartAnalysis)
      return `${this.aiChartAnalysis.name ?? ""} (${this.aiChartAnalysis.currency ?? ""})`.trim();
    return "Chart Analysis";
  }

  get containerPadding() {
    if (this.$vuetify.breakpoint.xs)
      return "padding: 0px;";
    return "";
  }

  get lightTransparentColor() {
      return this.$store.state.ux.colorAccent5 + "40";
  }

  goHome() {
    if (router.currentRoute.path == "/")
      return;
    router.push("/");
  }
}
